var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProspectPro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 88,
    viewBox: "0 0 86 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C9EEF7",
    d: "M35.718 66.713L13.07 43.875S55.662-6.975 78.197 1.913c-.112 0 10.48 24.3-42.479 64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAA9E",
    d: "M37.296 80.1l-1.282-13.406 19.174-16.503s1.15 10.109-.765 16.971L37.296 80.1zM30.986 25.087L13.07 43.876.338 40.5s7.775-8.663 15.324-13.163l15.324-2.25z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.69,
    cy: 30.488,
    fill: "#64CFE9",
    rx: 8.563,
    ry: 8.55
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64CFE9",
    d: "M17.24 48.038l-7.55 3.937 17.465 17.212 3.83-7.2zM61.651 3.6c1.66-1.376 10.764-3.917 16.398-1.78 0 0 2.366 4.513-.793 16.234 0 .113-14.478-4.666-15.605-14.454z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E5352C",
    d: "M18.773 59.863C8.158 55.953 1.9 65.332 0 88c18.982-5.213 27.57-12.416 25.765-21.61-1.499 3.984-6.373 7.047-14.621 9.19 0-8.207 2.543-13.446 7.63-15.717z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBC9A",
    d: "M20.675 59.575C12.853 56.97 8.242 63.221 6.842 78.333c13.987-3.475 20.315-8.277 18.985-14.406-1.105 2.656-4.696 4.698-10.774 6.126 0-5.471 1.874-8.964 5.622-10.478z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspectPro);
export default __webpack_public_path__ + "static/media/prospect-pro.510e4e3f1290cb96c47e43d155a9f2cc.svg";
export { ForwardRef as ReactComponent };